/**
 * Application-wide constants
 */

/**
 * Tournament type constants
 * Used to identify different types of tournaments
 */
export const TOURNAMENT_TYPES = {
  AT_GAMES_4K: 'atgames-4k',
  AT_GAMES_HD: 'atgames-hd',
  AT_GAMES_ALL_LEGENDS: 'atgames-all-legends',
  STERN_CURRENT: 'stern-current',
  STERN_PAST: 'stern-past',
  UNKNOWN: 'unknown'
};

/**
 * Tournament type display names
 * Maps tournament types to their display names
 */
export const TOURNAMENT_TYPE_DISPLAY = {
  [TOURNAMENT_TYPES.AT_GAMES_4K]: '4K',
  [TOURNAMENT_TYPES.AT_GAMES_HD]: 'HD',
  [TOURNAMENT_TYPES.AT_GAMES_ALL_LEGENDS]: 'ALL',
  [TOURNAMENT_TYPES.STERN_CURRENT]: 'Current',
  [TOURNAMENT_TYPES.STERN_PAST]: 'Past',
  [TOURNAMENT_TYPES.UNKNOWN]: 'Unknown'
};

/**
 * Get the display name for a tournament type
 * @param {string} type - The tournament type
 * @returns {string} The display name for the tournament type
 */
export const getTournamentTypeDisplay = (type) => {
  return TOURNAMENT_TYPE_DISPLAY[type] || type;
};